import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Header from 'components/header/header';
import InternetStatus from 'components/internet-status/internet-status';
import { useContext } from 'react';
import { Outlet } from 'react-router';
import { SideTabContext } from 'context/sidetab-context';
const ExamLayout = () => {
    const { showSideBar } = useContext(SideTabContext);
    return (_jsxs("div", Object.assign({ className: showSideBar ? 'container--exam-student' : 'container--exam-student container--main--fullwidth' }, { children: [_jsx(InternetStatus, {}, void 0), _jsx(Header, {}, void 0), _jsx(Outlet, {}, void 0)] }), void 0));
};
export default ExamLayout;
